import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSession } from '../context/SessionContext';

export function KeyraCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refresh, resumePendingAction } = useSession();
  const [error, setError] = useState<string | null>(null);
  const [working, setWorking] = useState(true);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state') ?? sessionStorage.getItem('spinit_keyra_state');

    if (!code || !state) {
      setError('Missing authorization parameters.');
      setWorking(false);
      return;
    }

    void import('../lib/api')
      .then(({ api }) =>
        api.completeKeyra({ code, state }).then(async () => {
          sessionStorage.removeItem('spinit_keyra_state');
          await refresh();
          navigate(resumePendingAction() ?? '/', { replace: true });
        }),
      )
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'Authentication failed');
        setWorking(false);
      });
  }, [searchParams, refresh, resumePendingAction, navigate]);

  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>
        {working ? 'Completing Keyra sign-in…' : 'Sign-in failed'}
      </h1>
      {error ? <p className="err">{error}</p> : <p className="muted">Restoring your session.</p>}
      {!working ? (
        <button type="button" className="btn primary" onClick={() => navigate('/')}>
          Back to feed
        </button>
      ) : null}
    </main>
  );
}
